<template>
  <span>⭐</span>
</template>

<script lang="ts" setup>
/** Заглушка рейтинга до подключения общего UI-компонента. */
defineProps<{
  hint?: string;
  oneStar?: boolean;
  size?: number;
  value?: number;
}>();
</script>
